/* global modForm Modalytics */
import { getFormData } from '../../helpers';

/**
 * Returns the CROTag payload for Heap from current form data.
 * Keys are CRO field names (e.g. ConvertRemodelReasons, ExistingProblems); values are comma-separated selected options.
 * @returns {Object.<string, string>} CROTag payload for Heap, or empty object if none.
 */
export function getCROTagPayloadForHeap() {
	const formData = getFormData();
	if (!formData.CROTag) {
		return {};
	}
	try {
		return JSON.parse(formData.CROTag);
	} catch (_) {
		return {};
	}
}

/**
 * Sends CROTag data to Heap when the user completes a form step.
 * Only tracks when the payload has changed from the last sent payload (stored in modForm.opts.croTagHeapPayload)
 * to avoid duplicate events when the user advances without changing CRO answers or goes back and re-completes with the same answers.
 * Side effects: tracks 'CROTag' event in Heap and sets modForm.opts.croTagHeapPayload to the sent payload.
 * @returns {void}
 */
export function trackCROTagToHeap() {
	const payload = getCROTagPayloadForHeap();

	if (Object.keys(payload).length === 0 || (modForm.opts.croTagHeapPayload !== null && JSON.stringify(payload) === JSON.stringify(modForm.opts.croTagHeapPayload))) {
		return;
	}

	Modalytics.heap('track', ['CROTag', payload]);
	modForm.opts.croTagHeapPayload = { ...payload };
}
